import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { TrashIcon, PlusIcon } from "lucide-react";
import { ConditionItem } from "./ConditionItem";

interface Condition {
  id?: string;
  field_id: string;
  datapoint_id: string;
  operator: "AND" | "OR" | "ONLY" | "NOT";
}

interface ConditionSetItemProps {
  id?: string;
  conditions: Condition[];
  onDelete: () => void;
  onChange: (conditions: Condition[]) => void;
}

export function ConditionSetItem({ id, conditions, onDelete, onChange }: ConditionSetItemProps) {
  const handleAddCondition = () => {
    const newCondition: Condition = {
      field_id: "",
      datapoint_id: "",
      operator: "AND",
    };
    onChange([...conditions, newCondition]);
  };

  const handleDeleteCondition = (index: number) => {
    const updatedConditions = [...conditions];
    updatedConditions.splice(index, 1);
    onChange(updatedConditions);
  };

  const handleConditionChange = (
    index: number,
    field_id: string,
    datapoint_id: string,
    operator: "AND" | "OR" | "ONLY" | "NOT",
  ) => {
    const updatedConditions = [...conditions];
    updatedConditions[index] = {
      ...updatedConditions[index],
      field_id,
      datapoint_id,
      operator,
    };
    onChange(updatedConditions);
  };

  return (
    <Card className="mb-4">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <div className="font-semibold">
          Condition Set {conditions.length > 0 ? `(${conditions.length} conditions)` : ""}
        </div>
        <Button variant="destructive" size="sm" onClick={onDelete}>
          <TrashIcon className="h-4 w-4 mr-2" /> Remove Set
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        {conditions.map((condition, index) => (
          <ConditionItem
            key={index}
            fieldId={condition.field_id}
            datapointId={condition.datapoint_id}
            operator={condition.operator}
            onDelete={() => handleDeleteCondition(index)}
            onChange={(field_id, datapoint_id, operator) =>
              handleConditionChange(index, field_id, datapoint_id, operator)
            }
          />
        ))}
        <Button variant="outline" size="sm" onClick={handleAddCondition} className="w-full">
          <PlusIcon className="h-4 w-4 mr-2" />
          Add Condition
        </Button>
      </CardContent>
    </Card>
  );
}
